import { render, staticRenderFns } from "./weightStationsRegistrationsView.vue?vue&type=template&id=dbb41000&"
import script from "./weightStationsRegistrationsView.vue?vue&type=script&lang=js&"
export * from "./weightStationsRegistrationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports